var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "main-wrapper" },
    [
      _c(
        "el-col",
        { staticClass: "main-banner-img-wrapper", attrs: { span: 24 } },
        [
          _c("img", {
            staticClass: "main-banner-img",
            attrs: {
              src: require("../../assets/how-it-work-banner.png"),
              alt: "img"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticClass: "main-paragraph-wrapper", attrs: { span: 24 } },
                [
                  _c("span", { staticClass: "main-paragraph" }, [
                    _vm._v(
                      "Welcome to UNIFI Property, the new destination for searching and exploring tomorrow’s Real Estate, featuring apartments, townhouses,\n            house and land, land with newly completed and under construction homes. Starting your journey of purchasing a brand-new property can be\n            daunting, and we are here to give you all the information you need to make an informed decision."
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "main-paragraph" }, [
                  _vm._v(
                    "Our decades long experience means we know that development properties are different to established homes. We built UNIFI Property to\n            redefine how these properties are presented to you, the buyer. Because detail matters, every listing has comprehensive data on each\n            individual home including:"
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  staticClass: "inclusion-img-wrapper",
                  attrs: { span: 20, offset: 2 }
                },
                [
                  _c("img", {
                    staticClass: "inclusion-img",
                    attrs: {
                      src: require("../../assets/how-it-work-inclusion-img.jpg"),
                      alt: "img"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "inclusion-description-wrapper",
                  attrs: { span: 22, offset: 1 }
                },
                [
                  _c("p", { staticClass: "sub-paragraph" }, [
                    _vm._v(
                      "Each property includes individual floor plans and development site plans, providing a detailed overview of the layout and location. It\n            also features a comprehensive price list showing the price, details, and availability of each individual home. Buyers can access\n            specification guides and brochures to understand the features and finishes of the properties. Additionally, a rental appraisal is included\n            to offer insights into potential rental returns. A full summary of all associated fees is provided, covering stamp duty, transfer costs,\n            council rates, and strata fees, ensuring complete transparency\n          "
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticClass: "steps-section-paragraph-wrapper",
                  attrs: { span: 24 }
                },
                [
                  _c("span", { staticClass: "main-paragraph" }, [
                    _vm._v(
                      "If you find a home you love, you can contact the agent directly from the listing or use our unique "
                    ),
                    _c("strong", [_vm._v("RESERVATION")]),
                    _vm._v(
                      " feature.  This allows you to\n            reserve your property completely online in a few easy steps.  Holding your selected property for an exclusive 7-day period to kickstart the\n            purchasing process with the Agent and take your property off the market."
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "steps-section" },
            [
              _c("el-col", { attrs: { xs: 24, sm: 24, md: 14, lg: 14 } }, [
                _c("div", { staticClass: "steps-section-img-container" }, [
                  _c("img", {
                    staticClass: "steps-section-img",
                    attrs: {
                      src: require("../../assets/how-it-work-steps-img.jpeg"),
                      alt: "how it work steps image"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "steps-section-column",
                  attrs: { xs: 24, sm: 24, md: 14, lg: 10 }
                },
                [
                  _c("h2", { staticClass: "steps-title" }, [_vm._v("STEPS:")]),
                  _vm._v(" "),
                  _c("ol", { staticClass: "steps-list" }, [
                    _c("li", { staticClass: "steps-list-item" }, [
                      _c("span", { staticClass: "steps-list-item-text" }, [
                        _vm._v(
                          "1. Complete the online form with all details of the purchaser and conveyancer or solicitor."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "steps-list-item" }, [
                      _c("span", { staticClass: "steps-list-item-text" }, [
                        _vm._v(
                          "2. Click “Pay and Submit Reservation” to pay the $1,000 reservation fee securely online."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "steps-list-item" }, [
                      _c("span", { staticClass: "steps-list-item-text" }, [
                        _vm._v(
                          "3. Once your reservation is received, the Agent will\n                contact you directly to prepare the contract of sale and take you through next steps."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "steps-list-item" }, [
                      _c("span", { staticClass: "steps-list-item-text" }, [
                        _vm._v(
                          "4. Upon the expiry of the 7-day reservation period, your\n                $1,000 reservation fee will be refunded via your original method of payment"
                        )
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticClass: "steps-section-paragraph-wrapper",
                  attrs: { span: 24 }
                },
                [
                  _c("span", { staticClass: "main-paragraph" }, [
                    _vm._v(
                      "Start fresh in a brand-new home, that you can potentially customise to your preferences and take advantage of government incentives. Stop\n            searching through properties that don’t meet your needs or spending your weekends at open inspections and search UNIFI Property for your\n            real estate needs."
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "main-paragraph" }, [
                  _vm._v(
                    "There are a range of benefits of selecting a brand new or development property rather than an established home, such as;"
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "benefits-section" },
            [
              _c(
                "el-col",
                {
                  staticClass: "benefit-section-column",
                  attrs: { xs: 24, sm: 24, md: 14, lg: 10 }
                },
                [
                  _c("ul", { staticClass: "benefit-list" }, [
                    _c("li", { staticClass: "benefit-list-item" }, [
                      _c("span", { staticClass: "benefit-list-item-text" }, [
                        _vm._v("• Modern amenities and features")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "benefit-list-item" }, [
                      _c("span", { staticClass: "benefit-list-item-text" }, [
                        _vm._v(
                          "• Ability to customise finishes, materials and layouts to suit your preferences"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "benefit-list-item" }, [
                      _c("span", { staticClass: "benefit-list-item-text" }, [
                        _vm._v("• Reduced maintenance and repair costs")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "benefit-list-item" }, [
                      _c("span", { staticClass: "benefit-list-item-text" }, [
                        _vm._v("• Energy efficient appliances")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "benefit-list-item" }, [
                      _c("span", { staticClass: "benefit-list-item-text" }, [
                        _vm._v(
                          "• Potential to take advantage of government incentives and stamp duty relief"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "benefit-list-item" }, [
                      _c("span", { staticClass: "benefit-list-item-text" }, [
                        _vm._v("• Lifestyle and community advantages")
                      ])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("el-col", { attrs: { xs: 24, sm: 24, md: 14, lg: 14 } }, [
                _c("div", { staticClass: "benefit-section-img-container" }, [
                  _c("img", {
                    staticClass: "benefit-section-img",
                    attrs: {
                      src: require("../../assets/how-it-work-new-property.png"),
                      alt: "Property feature image"
                    }
                  })
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "main-paragraph" }, [
                  _vm._v(
                    "At UNIFI Property, we are committed to simplifying your journey to owning a brand-new home by providing unparalleled detail, transparency, and convenience—empowering you to make confident, informed decisions about your future in a modern, thoughtfully designed property."
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dbca950c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbca950c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/howItWorks/howItWorksContent.vue
// module id = null
// module chunks = 